import type { ComponentProps } from "react";
import { cn } from "@/utils";

export const BrowserWindow = ({ children, className, ...props }: ComponentProps<"div">) => {
	return (
		<WindowShadow className={className} {...props}>
			<div className="px-0.5 pb-0.5 md:px-2 md:pb-2">
				<div>
					<div className="h-1.5 flex flex-row items-center gap-0.5 md:h-7 md:gap-1.5">
						<div className="rounded-full bg-neutral-200 size-[3px] md:size-3" />
						<div className="rounded-full bg-neutral-200 size-[3px] md:size-3" />
						<div className="rounded-full bg-neutral-200 size-[3px] md:size-3" />
					</div>
					<div className="aspect-video bg-white rounded-xs border border-neutral-200 md:rounded-lg overflow-clip">
						{children}
					</div>
				</div>
			</div>
		</WindowShadow>
	);
};

export const WindowShadow = ({
	children,
	className,
	innerClassName,
	...props
}: ComponentProps<"div"> & { innerClassName?: string }) => {
	return (
		<div className={cn("bg-black/5 rounded-md p-1 -mx-1 z-20 relative md:rounded-xl", className)} {...props}>
			<div className={cn("bg-white rounded-sm md:rounded-lg h-full", innerClassName)}>{children}</div>
		</div>
	);
};
